import axios from 'axios'; // import { saveAs } from 'file-saver';
import { getAuthHeaders, createAction, toQueryString } from '../../utils/utils';

export const LOAD = '[PerformanceReport] LOAD';
export function load() {
  return { type: LOAD };
}

export const LOAD_SUCCESS = '[PerformanceReport] LOAD_SUCCESS';
export function loadSuccess(data) {
  return { type: LOAD_SUCCESS, data };
}

export const LOAD_FAILED = '[PerformanceReport] LOAD_FAILED';
export function loadFailed(error) {
  return { type: LOAD_FAILED, error };
}
export const LOAD_ONE = '[PerformanceReport] LOAD_ONE';
export function loadOne() {
  return { type: LOAD_ONE };
}

export const LOAD_SUCCESS_ONE = '[PerformanceReport] LOAD_SUCCESS_ONE';
export function loadSuccessOne(data) {
  return { type: LOAD_SUCCESS_ONE, data };
}

export const LOAD_FAILED_ONE = '[PerformanceReport] LOAD_FAILED_ONE';
export function loadFailedOne(error) {
  return { type: LOAD_FAILED_ONE, error };
}

export const EXPORT = '[File] EXPORT';
export function exportDocument() {
  return { type: EXPORT };
}

export const EXPORT_SUCCESS = '[File] EXPORT_SUCCESS';
export function exportSuccess(file) {
  return { type: EXPORT_SUCCESS, file };
}

export const EXPORT_FAIL = '[File] EXPORT_FAIL';
export function exportFailed(error) {
  return { type: EXPORT_FAIL, error };
}

export const VOID = '[PerformanceReport] VOID';
export function emptyReport() {
  return { type: VOID };
}


export function fetchAll(filters = {}) {
  return async function (dispatch, getState) {
    dispatch(load());

    try {
      let url = `${window.config.API_URL_USER}canHistory`;
      // url = `${window.config.API_URL_ORDER}requirements?stateFilter=${stateFilter}`;

      if (Object.keys(filters).length) {
        url = `${url}?${toQueryString(filters)}`;
      }

      const res = await axios.get(url, {
        headers: getAuthHeaders(getState()),
      });

      if (res.status === 201) {
        dispatch(loadSuccess(res.data.data));
      } else {
        dispatch(loadFailed(res.data.message));
      }
    } catch (err) {
      dispatch(loadFailed(err));
    }
  };
}
